import { render, staticRenderFns } from "./NewDnsModal.vue?vue&type=template&id=10c682e5&"
import script from "./NewDnsModal.vue?vue&type=script&lang=js&"
export * from "./NewDnsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports